class ZavyroArticleToc extends HTMLElement {
  connectedCallback() {
    const article = document.querySelector('[data-zavyro-article-body]');
    const list = this.querySelector('ol');
    if (!article || !list) return;

    const headings = [...article.querySelectorAll('h2, h3')];
    if (headings.length < 2) return;

    const usedIds = new Set();
    headings.forEach((heading, index) => {
      const base = (heading.id || heading.textContent || `section-${index + 1}`)
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || `section-${index + 1}`;
      let id = base;
      let suffix = 2;
      while (usedIds.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
        id = `${base}-${suffix}`;
        suffix += 1;
      }
      heading.id = id;
      usedIds.add(id);

      const item = document.createElement('li');
      item.dataset.level = heading.tagName.slice(1);
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });

    this.hidden = false;
  }
}

if (!customElements.get('zavyro-article-toc')) {
  customElements.define('zavyro-article-toc', ZavyroArticleToc);
}

const hideBrokenEditorialImage = (image) => {
  image.hidden = true;
  image.setAttribute('aria-hidden', 'true');
  image.removeAttribute('srcset');
};

document.querySelectorAll('[data-zavyro-article-body] img').forEach((image) => {
  image.addEventListener('error', () => hideBrokenEditorialImage(image), { once: true });
  if (image.complete && image.naturalWidth === 0) hideBrokenEditorialImage(image);
});

const classifyZavyroInternalLink = (link) => {
  if (!link || link.dataset.zavyroLinkType) return;
  let pathname;
  try { pathname = new URL(link.href, window.location.origin).pathname; } catch { return; }
  if (pathname.startsWith('/blogs/magazine/')) link.dataset.zavyroLinkType = 'article';
  else if (pathname.startsWith('/collections/')) link.dataset.zavyroLinkType = 'collection';
  else if (pathname.startsWith('/products/')) link.dataset.zavyroLinkType = 'product';
  if (link.dataset.zavyroLinkType) link.dataset.zavyroSource = link.dataset.zavyroSource || 'magazine-editorial';
};

document.querySelectorAll('.zavyro-editorial a[href]').forEach(classifyZavyroInternalLink);
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('.zavyro-editorial a[data-zavyro-link-type]');
  if (!link || !Array.isArray(window.dataLayer)) return;
  window.dataLayer.push({
    event: 'zavyro_magazine_internal_click',
    link_type: link.dataset.zavyroLinkType,
    link_source: link.dataset.zavyroSource || 'magazine',
    link_destination: new URL(link.href, window.location.origin).pathname,
  });
});
